import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Flex, FlexProps } from '@chakra-ui/react';
import { validatePages } from 'utils/auth';
import { useUser, useSession } from 'contexts';
import { sessionExpiry } from 'constants/validation';
import AccessDenied from 'components/common/Layout/AccessDenied';
import Header from 'components/common/Layout/Header';
import { ConfiguratorQueryParams } from 'types/designAutomation/configurator';
import { Pages } from 'constants/pages';

type LayoutProps = {
  children: React.ReactNode;
  className?: string;
  testId?: string;
  pages?: Pages[];
  matchAll?: boolean;
  queryParams?: ConfiguratorQueryParams;
  containerProps?: FlexProps;
  bodyProps?: FlexProps;
  pageProps?: FlexProps;
  sx?: object;
};

const Layout = ({
  children,
  className,
  pages = [],
  matchAll = false,
  queryParams,
  containerProps,
  bodyProps,
  pageProps,
  testId,
  sx,
}: LayoutProps) => {
  const [user] = useUser();

  const [, setError] = useSession();

  const [redirect, setRedirect] = useState<string>();

  useEffect(() => {
    if (!user && !queryParams?.product) {
      setError(sessionExpiry);
      setRedirect('/');
    }
  }, [user]);

  if (!user && !queryParams?.product && redirect) {
    return <Navigate to={redirect} replace />;
  }

  const page =
    pages.length > 0 && !validatePages(user?.role?.pages ?? [], pages, matchAll) ? <AccessDenied /> : children;

  return (
    <Flex
      {...containerProps}
      data-testid={testId}
      sx={{
        flex: 1,
        overflowX: 'hidden',
        maxW: '100vw',
        ...(containerProps?.sx ?? {}),
      }}
    >
      <Flex {...bodyProps} className={className} flex={1} flexDir="column" maxW="100vw" sx={sx}>
        <Header queryParams={queryParams} />
        <Flex {...pageProps} flex={9}>
          {page}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Layout;
